<template>
	<v-col class="stockist">
		<ModalSearch ref="modalSearch" @action="cari"></ModalSearch>
		<ModalDetail :stockist="selectedStockist" ref="modalDetail"></ModalDetail>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">List Stockist</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-card-bulleted</v-icon>
			<div class="pl-2">List Stockist</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12" class="">
					<div class="d-flex justify-end">
						<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Cari</div>
							</div>
						</v-btn>
						<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="reset">Reset</v-btn>
					</div>
				</v-col>
			</v-row>
			<div class="mt-3" v-if="!loading">
				<v-row class="ml-0" v-if="listStockist.length > 0">
					<v-col cols="12" sm="12" md="3" xl="2" class="pl-0 pt-0 col-md-20" v-for="stockist in listStockist" :key="stockist.stockist_code">
						<v-card class="pa-3 elevation-0 rounded-lg hover-shadow fill-height">
							<a href="javascript:void(0)" title="Klik untuk melihat detail Produk" @click="showDetailStockist(stockist)">
							<v-img contain height="165px" class="rounded-lg" :src="(stockist.stockist_image) ? stockist.stockist_image : '/assets/image/user-pict.jpg'"></v-img>
							</a>
							<div class="pt-3">
								<div class="font-size-11 product-name font-weight-bold">{{ stockist.stockist_name }}</div>
								<div class="font-size-10 cl-primary">{{ stockist.stockist_code }}</div>
								<div class="font-size-9 cl-grey font-weight-500">{{ stockist.stockist_mobilephone }}</div>
								<div class="pt-2 font-size-9 cl-grey">{{ stockist.stockist_city_name }}</div>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listStockist.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada list stockist yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listStockist.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="stockistPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ stockistPagination.total_display }} data dari total {{ stockistPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSearch from './components/ModalSearch';
import ModalDetail from './components/ModalDetail';

export default {
	components: {
		ModalSearch, ModalDetail
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
			selectedStockist: null
		}
	},
	computed: {
		...mapState('stockist', ['listStockist', 'stockistPagination']),
	},
	methods: {
		...mapActions('stockist', ['getStockist']),

		getData() {
			this.loading = true
			this.getStockist(this.queryString({limit:this.limit, page: this.page, params: this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		showSearch() {
			this.$refs.modalSearch.modalShow()
		},
		reset() {
			this.page = 1
			this.limit = '10'
			this.params = []
			this.getData()
			this.$refs.modalSearch.reset()
		},
		cari(data) {
			this.params = []
			this.page = 1

			if(data.name.value)
				this.params.push(data.name)
			if(data.code.value)
				this.params.push(data.code)
			if(data.handphone.value)
				this.params.push(data.handphone)
			if(data.province_id.value)
				this.params.push(data.province_id)
			if(data.city_id.value)
				this.params.push(data.city_id)
			this.getStockist(this.queryString({limit:this.limit, page: this.page, params: this.params})).then(() => {
				this.$refs.modalSearch.modalHide()
			})
		},

		showDetailStockist(stockist) {
			this.selectedStockist = stockist
			this.$refs.modalDetail.modalShow()
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `List Stockist`)
		this.getData()
	},
};
</script>
